import React from 'react';
import { contentBlocks } from '../../data/content';
import { CtaButton } from '../CtaButton';
export function ContentSection() {
  return <section className="w-full bg-bone px-4 py-14 sm:px-6 sm:py-20" data-id="element-127" data-mp="2puu63q9w97r2">
      <div className="mx-auto w-full max-w-5xl" data-id="element-128" data-mp="2uwjgr4t7fjem">
        <div className="mx-auto max-w-2xl text-center" data-id="element-129" data-mp="2utovxc6a3wko">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.24em] text-blood" data-id="element-130" data-mp="2ztjjp6urc61i">
            Content
          </p>
          <h2 className="mt-3 font-display text-[26px] font-extrabold leading-tight text-ink sm:text-4xl" data-id="element-131" data-mp="228nm05n741kh">
            Everything you need to manage hypertension — from diagnosis to
            long-term follow-up
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-graphite/75 sm:text-base" data-id="element-132" data-mp="2gvqkaejcee8v">
            No jumping between articles, guidelines, notes and scattered
            references. Hypertension Route organizes the clinical process into a
            logical pathway so you can quickly identify what to do next.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-133" data-mp="1uqh245kmtkn7">
          {contentBlocks.map(block => <article key={block.title} className="flex h-full flex-col rounded-2xl bg-white p-5 shadow-card ring-1 ring-ink/[0.06]" data-id="element-134" data-mp="1pu8lsoup7leg">
              <span aria-hidden="true" className="text-2xl leading-none" data-id="element-135" data-mp="1gzc232dcqqcc">
                {block.emoji}
              </span>
              <h3 className="mt-3 font-display text-lg font-bold leading-snug text-ink" data-id="element-136" data-mp="170d54h1y8j56">
                {block.title}
              </h3>
              <p className="mt-2 text-[14px] leading-relaxed text-graphite/75" data-id="element-137" data-mp="124e9c8eajyuq">
                {block.text}
              </p>
            </article>)}
        </div>

        <div className="mt-10 flex justify-center" data-id="element-138" data-mp="2wfsz2p7axyah">
          <CtaButton label="I want the complete clinical system" data-id="element-139" data-mp="2sf0qly697xf9" />
        </div>
      </div>
    </section>;
}